import React from 'react'
import Popup from 'react-popup'
import intl from 'react-intl-universal'
import Lightbox from 'react-simple-lightbox'
import { connect } from 'react-redux'
import { b64EncodeUnicode } from '../utils/Tools'
import { ReactComponent as Check } from '../assets/check.svg'

function printBundle(product, parent, group_treshold){
  const { product_confirmation_method } = parent.props
  let product_uom_qty = product.product_uom_qty
  if(product.product_uom_qty < group_treshold){
    product_uom_qty = 1
  }
  return (
    <div className="ramka bundleItemList">
      <table>
        <tbody>
          {product.items.map((item, index) => {
            return (<tr data-barcode={item.barcode || ''} data-name={b64EncodeUnicode(item.product_name || '')} data-code={item.default_code || ''} data-qty={item.qty_uom} key={`${product.line_id}_${index}`}>
              <td>
                [{item.default_code || ''}] {item.name}
              </td>
              <td className="width1">
                <span className="smaller">{product_uom_qty} x {item.qty_uom} = </span>
                {product_uom_qty * item.qty_uom} szt.
              </td>
              <td className="width1">
                <div className={`checkbox multiproduct${['click', 'scan_click'].includes(product_confirmation_method)?' clickable':''}`} data-bundle-item-qty={item.qty_uom} onClick={parent.checkboxClick}>
                  <Check className="check"/>
                </div>
              </td>
            </tr>)
        })}
        </tbody>
      </table>
    </div>
  )
}

const mapStateToProps = state => ({
  product_confirmation_method: state.config.product_confirmation_method,
  verify_qty: state.config.verify_qty,
  stock_location: state.config.stock_location,
  group_treshold: state.config.group_treshold,
  bundle_select: state.config.bundle_select || false
})

class ProductListItemComponent extends React.Component {
  checkboxClick = (event) => {
    const { product_confirmation_method, verify_qty, group_treshold, product, parent, bundle_select } = this.props
    const bundle_qty = event.currentTarget.dataset['bundleItemQty']
    if(['click', 'scan_click'].includes(product_confirmation_method)){
      if(product.is_bundle &&
         event.currentTarget.classList.contains('mainCheckbox') &&
         !bundle_select){
        return
      }
      let $checkbox = event.currentTarget
      let $produkt = event.currentTarget.closest('.produkt.ramka')
      let cnt = $produkt.getAttribute('data-prods')
      if(typeof bundle_qty != 'undefined'){
        cnt = cnt * parseInt(bundle_qty)
      }
      const self = this
      if(verify_qty && cnt >= (group_treshold || 10) && !$checkbox.classList.contains('checked')){
        Popup.create({
          content: intl.get('Czy na pewno spakowałeś X pozycji tego SKU?', {cnt: cnt}),
          buttons: {
            right: [{
              text: intl.get('Tak'),
              key: 'enter',
              action: function () {
                Popup.close()
                $checkbox.classList.toggle('checked')
                if(!event.currentTarget.classList.contains('mainCheckbox')){
                  self.bundleItemsCollected($produkt, parent)
                }
                parent.toggleConfirmButton()
              }
            },
            {
              text: intl.get('Nie'),
              className: 'cancel-button',
              action: function () {
                Popup.close()
              }
            }]
          }
        })
        return
      } else {
        $checkbox.classList.toggle('checked')
        if(!event.currentTarget.classList.contains('mainCheckbox')){
          self.bundleItemsCollected($produkt, parent)
        }
      }
      if($produkt.querySelector('.bundleItemList')){
        if(event.currentTarget.classList.contains('mainCheckbox') && bundle_select){
          let elems = $produkt.querySelectorAll('.bundleItemList .checkbox')
          for (let i = 0; i < elems.length; ++i) {
            elems[i].classList.toggle('checked', $checkbox.classList.contains('checked'))
          }
        }
      }
      parent.toggleConfirmButton()
    }
  }

  bundleItemsCollected = ($produkt, parent) => {
    const alldone = !$produkt.querySelector('.bundleItemList .checkbox:not(.checked)')
    $produkt.querySelector('.product_checkbox .checkbox').classList.toggle('checked', alldone)
  }

  render() {
    const { product, qty, supercount, stock_location, group_treshold, product_confirmation_method } = this.props
    const odoo = window.ODOO.url + (window.ODOO.port?':'+window.ODOO.port:'')+'/product/image?default_code='
    let className = 'ramka produkt'+
                    (supercount?' supercount':'')+
                    (product.red?' red':'')+
                    (product.is_bundle?' has_bundle':'')+
                    (product.show_as_dropshipping_product?' dropshipping_product':'')
    let service = product.product_type === 'service'
    return (
      <div className={className} data-prods={qty} data-barcode={product.barcode || ''} data-name={b64EncodeUnicode(product.product_name || '')} data-code={product.default_code || ''}>
        <div>
          <div className="dropshipping_label">Dropshipping</div>
          <Lightbox key={product.line_id}>
            <img src={odoo+product.quote_default_code} alt="product"/>
          </Lightbox>
          <div className="product_details">
            <h4>
              {product.product_name}
              {product.default_code &&
                <div className="default_code" data-code={product.default_code}>[{product.default_code}]</div>
              }
            </h4>
            <div className="qty f_group">
              <label>{intl.get('Ilość')}:</label>
              <div>{qty} {product.uom_name}</div>
            </div>
            <div className="price f_group">
              <label>{intl.get('Cena jednostkowa')}:</label>
              <div>{product.price_unit_gross}</div>
            </div>
            {stock_location &&
              <div className="stock_location f_group">
                <label>{intl.get('Strefa składowania')}:</label>
                <div>{product.location}</div>
              </div>
            }
            {product.packing_zone_notes &&
              <div className="notes f_group">
                <label>{intl.get('Uwagi do pakowania')}:</label>
                <div>{product.packing_zone_notes}</div>
              </div>
            }
          </div>
          {!service &&
            <div className={`product_checkbox${['click', 'scan_click'].includes(product_confirmation_method)?' clickable':''}`} data-line={product.line_id}>
              <div className="checkbox mainCheckbox" onClick={this.checkboxClick}>
                <Check className="check"/>
              </div>
            </div>
          }
        </div>
        { product.is_bundle &&
          <div className="bundleWrapper">
            {printBundle(product, this, (group_treshold || 10))}
          </div>
        }
      </div>
    )
  }
}

const ProductListItem = connect(mapStateToProps)(ProductListItemComponent)
export default ProductListItem
